import React, { useState, useEffect } from 'react';
import {Redirect} from 'react-router'
import axios from 'axios';
// import {
//     Colxx,
//     Separator,
// } from '../../../components/common/CustomBootstrap';
import {
    Row,
    Card,
    CardBody,
} from 'reactstrap';

import { toast } from 'react-toastify';
import Breadcrumb from '../common/breadcrumb';
import { faLifeRing } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'




class SpecialNumbers extends React.Component {

	constructor(props) {
        super(props);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.saveHandler = this.saveHandler.bind(this);
        this.cancelHandler = this.cancelHandler.bind(this);
    }
    state ={
        backToSummary: false,
        data: {},
        style: 'custom-spinner',
        addItem:false,
        addingFirstTime: true,
        showModal: false,
    };

    headers = {
        headers: {
            Token: localStorage.getItem("token"),
        }
    }

    inputChangeHandler(event) {

        const maxLength = event.target.getAttribute("maxLength");
        if(event.target.value.length > maxLength && maxLength){
            event.target.value = event.target.value.slice(0,maxLength);
        }
        if(event.target.value < event.target.min && event.target.min && event.target.value !==""){
            event.target.value = event.target.min;
        }

        var data = this.state.data
        data[event.target.name] = event.target.value;
        this.setState({data});

    }

    addHandler = () => {
        if(this.state.addingFirstTime){
            this.setState({addItem: true});
            this.setState({addingFirstTime: false});
            return;
        }
        if(!this.state.data.name || !this.state.data.number){
            toast.error("Name and Number are compulsary fields first fill them out");
            return;
        }
        this.setState({loading: true});
        let payLoad = {
            name : this.state.data.name,
            number : this.state.data.number,
            client_profile_id: this.props.location.state.client_profile_id
        };
        axios.post(`${process.env.REACT_APP_API_URL}addSpecialNumber`, payLoad, this.headers)
        .then(response=>{
            let data = this.state.data;
            data["name"] = "";
            data["number"] = "";
            this.setState({data});
            this.refreshData(true);
        })
        .catch(err=>{
            toast.error(err.message);
            this.setState({loading: false});
        });
    }

    saveHandler(event){
        if(!this.state.data.name || !this.state.data.number){
            toast.error("Name and Number are compulsary fields first fill them out");
            return;
        }
        let payLoad = {
            name : this.state.data.name,
            number : this.state.data.number,
            client_profile_id: this.props.location.state.client_profile_id
        };
        axios.post(`${process.env.REACT_APP_API_URL}addSpecialNumber`, payLoad, this.headers)
        .then(response=>{
            this.setState({backToSummary: true});
        })
        .catch(err=>{
            toast.error(err.message);
            this.setState({loading: false});
        });
    }

    deleteHandler = (evt) => {
        this.setState({loading: true});
        
        let payLoad = {
            id : evt.target.getAttribute("data-id"),
            client_profile_id: this.props.location.state.client_profile_id
        };
        axios.post(`${process.env.REACT_APP_API_URL}deleteSpecialNumber`, payLoad, this.headers)
        .then(response=>{
            this.refreshData(false);
        })
        .catch(err=>{
            toast.error(err.message);
            this.setState({loading: false});
        });
    }

    cancelHandler(){
        this.setState({backToSummary: true});
    }

    refreshData = (addNew) => {
        this.setState({loading: true});
        this.setState({loading: true});
        const payLoad = {
            client_profile_id:  this.props.location.state.client_profile_id,
        };
        axios.post(`${process.env.REACT_APP_API_URL}specialNumbersSummary`, payLoad, this.headers)
        .then(response=>{
            if(addNew){
                this.setState({addItem: true});
                this.setState({addingFirstTime: false});
            }
            const enteries = response.data;
            let items = enteries.map((row, index)=>{
                return(<div className="row form-group">

                <div className="col-md-6">
                    <input type="text" className="form-control" name="name"
                    value = {row.name} disabled/>
                </div>

                <div className="col-md-5">
                    <input type="text" className="form-control" name="number"
                    value = {row.number} disabled/>
                
                </div>
                <div className="col-md-1" style={{textAlign: "end"}}>
                <i class="fa fa-trash" style={{ cursor: "pointer"}} onClick={this.deleteHandler}
                        data-id={row.id}></i>                 
               
                    
                </div>

            </div>)
            });
            this.setState({enteriesList: items});
            this.setState({loading: false});
        })
        .catch(err=>{
            //toast.error("Failed to Load blf enteries!");
            this.setState({enteriesList: []});
            this.setState({loading: false});
        });
        
    }
    componentDidMount(){
        if(!this.props.location.state){
			this.setState({unAuthorized: true});
			return;
		}
        this.refreshData(false);
    }

    handleFiles = (files) => {
        var reader = new FileReader();
        const scope = this;
        reader.onload = function (e) {
            // Use reader.result
            const csv = reader.result;
            const lines = csv.split('\n');
            const result = [];
            const headers = ['name', 'number',];
            let key = null;
            let value = null;
            if(!lines[0].includes("name,number")){
                toast.error("Invalid Format");
                scope.setState({ csvData: null, CSVProcessed: false});
                return;
            }
            for (let i = 1; i < lines.length; i++) {
                if (!lines[i])
                    continue;
                const obj = {};
                const currentline = lines[i].split(',');
                for (let j = 0; j < headers.length; j++) {
                    key = headers[j];
                    value = currentline[j].replace('\r', '');
                    obj[key] = value;
                }
                
                result.push(obj);
            }
            
            scope.setState({ csvData: result, CSVProcessed: true });
        };
        
        reader.readAsText(files[0]);
    };

    uploadHandler = (evt) => {
        if(!this.state.id){
            toast.error("First enable the BLF");
            return;
        }
        let payLoad = this.state.csvData;
        for(let i=0; i< payLoad.length; i++){
            payLoad[i].subscriber_id = this.props.location.state.subscriber_id;
            payLoad[i].subscriber_attrs_id = this.state.id;
        }
        axios.post(`${process.env.REACT_APP_API_URL}addSpecialNumbers`, payLoad)
        .then(response=>{
            let data = this.state.data;
            data["name"] = "";
            data["number"] = "";
            this.setState({data});
            this.setState({CSVProcessed: false});
            this.setState({csvData: null});
            this.refreshData(true);
        })
        .catch(err=>{
            toast.error(err.message);
            this.setState({loading: false});
        });
    }

    editBlfHandler = (evt) => {
        this.setState({updateId: evt.target.getAttribute("data-id")});
        let data=this.state.data;
        data["updatedName"] = evt.target.getAttribute("data-name");
        data["updatedNumber"] = evt.target.getAttribute("data-number");
        this.setState({data});
        this.setState({showModal: true});
    }

    toggleModalHandler = () => {this.setState({showModal: !this.state.showModal})}

    updateHandler = (evt) => {
  

        let payLoad = {
            name : this.state.data.updatedName,
            number : this.state.data.updatedNumber,
            id: this.state.updateId
        };
        axios.post(`${process.env.REACT_APP_API_URL}updateBlfEntry`, payLoad, this.headers)
        .then(response=>{
            this.setState({showModal: false});
            this.refreshData(true);
        })
        .catch(err=>{
            toast.error(err.message);
            this.setState({loading: false});
        });
    }

    render(){
        let redirect = null;
		if (this.state.backToSummary) {
			this.setState({ backToSummary: false });
			redirect = <Redirect to={{
				pathname: '/client_profiles',
			}}/>;
		}
        if(this.state.unAuthorized){
			redirect = <Redirect to = {{
				pathname: "/unauthorized"
			}} />;
		}
        return(
            <div>
                {redirect}
                
                <Row>
                 
                        <Breadcrumb heading="menu.specialNumbers" match={this.props.match} />
                   
                </Row>

                <div className = "MainIndex">
                    <div className="page-header customTitleMiddle">
                        <h3 className="m-b-10">
                            {this.state.loading
                                ? <a>loading...</a>
                                : "Special Numbers For Profile " + this.props.location.state.profileNameSelected
                            }
                        </h3>
                    </div>
                    <div className="row">
                        <div className="col-sm-0 col-md-2"></div>
                        
                        <Card className="col-sm-12 col-md-8">
                            <CardBody>
                                <div className="row form-group">

                                    <div className="col-md-12" style={{textAlign: "end"}}>
                                        <i className="fas fa-plus-circle data-table-icon blf-add" title="Add BLF Entry" onClick={this.addHandler}/>
                                    </div>

                                </div>

                                <div className="row form-group">

                                    <div className="col-md-6">
                                        <label className="float-left"> Name  </label>
                                    </div>

                                    <div className="col-md-5" style={{textAlign: "end"}}>
                                        <label className="float-left"> Number  </label>
                                    </div>

                                </div>

                                {this.state.enteriesList}
                                <div>
                                    {this.state.addItem?
                                        <div className="row form-group">

                                            <div className="col-md-6">
                                                <input type="text" className="form-control" name="name" placeholder="Name" 
                                                    onChange={this.inputChangeHandler} value = {this.state.data.name}/>
                                            </div>

                                            <div className="col-md-5" >
                                                <input type="text" className="form-control" name="number" placeholder="Number"
                                                    onChange={this.inputChangeHandler} value = {this.state.data.number}/>
                                            </div>

                                        </div>
                                        :null
                                    }
                                </div>
                                <div className="row form-group">
                                    <div className="col-md-6">
                                        <button type="button" onClick={this.cancelHandler} className="button-custom btn shadow-2 mr-3 btn-secondary btn-width">
                                            CANCEL
                                        </button>
                                        <button type="button" onClick={this.saveHandler} className="button-custom btn shadow-2 btn-success btn-width">
                                            SAVE
                                        </button>
                                    </div>
                                    {/* <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <img width="100px" src={csvImg}/>
                                            </div>
                                            <div className="col-md-8">
                                                <h4 className="importer-csv-text">Bulk Import</h4>
                                                <ReactFileReader handleFiles={this.handleFiles} fileTypes={'.csv'}>
                                                    <button className='btn btn-dark' disabled={!this.state.enable_blf}>Click Here To Read CSV</button>
                                                </ReactFileReader>
                                                {this.state.CSVProcessed && this.state.enable_blf?
                                                    <span style={{color:"#20c997"}}>
                                                        <button className='btn btn-success' onClick={this.uploadHandler}
                                                        style={{marginLeft: "20px", marginTop: "10px"}}>Upload</button>
                                                    </span>
                                                    :null
                                                }

                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </CardBody>
                        </Card>
                        <div className="col-sm-0 col-md-2"></div>
                    
                    </div>
                </div>
                
                
            </div>

        )
    }
}

export default SpecialNumbers